import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import AdminInput from "components/admin/input"
import {EvaluationGroupsSelectWithContainer} from "components/evaluation-groups/select"
import {EvaluationRule} from "models"
import Link from "@kaspernj/api-maker/build/link"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import propTypesExact from "prop-types-exact"
import React from "react"
import Routes from "shared/routes"
import Select from "components/inputs/select"
import TranslatedCollections from "@kaspernj/api-maker/build/translated-collections"
import useI18n from "i18n-on-steroids/build/src/use-i18n.js"
import {v4 as uuidv4} from "uuid"

const Actions = memo(shapeComponent(class SuperAdminModelConfigsEvaluationRuleActions extends ShapeComponent {
  static propTypes = propTypesExact({
    evaluationRule: PropTypes.instanceOf(EvaluationRule).isRequired
  })

  setup() {
    const {t} = useI18n({namespace: "js.super_admin.model_configs.evaluation_rule.actions"})

    this.t = t
  }

  render() {
    const {t} = this.tt
    const {evaluationRule} = this.p

    return (
      <Link to={Routes.adminEvaluationRuleTestPath(evaluationRule.id())}>
        {t(".test")}
      </Link>
    )
  }
}))

export default {
  actions: ({model}) => <Actions evaluationRule={model} />,
  edit: {
    attributes: [
      {
        attribute: "evaluationGroupId",
        content: ({inputProps}) => (
          <EvaluationGroupsSelectWithContainer
            label={EvaluationRule.humanAttributeName("evaluationGroup")}
            {...inputProps}
          />
        ),
        label: EvaluationRule.humanAttributeName("evaluationGroup")
      },
      {attribute: "name", translated: true},
      {attribute: "active"},
      {attribute: "position"},
      {
        attribute: "liquidRule",
        content({inputProps}) {
          this.evaluationRuleLiquidRuleDataSet ||= {id: "evaluation_rule_liquid_rule"}
          const dataSet = this.evaluationRuleLiquidRuleDataSet

          return (
            <AdminInput
              autoRows
              dataSet={dataSet}
              defaultValue={inputProps.defaultValue}
              label={EvaluationRule.humanAttributeName("liquidRule")}
              multiline
              name={inputProps.name}
            />
          )
        }
      },
      {
        attribute: "ruleType",
        content: ({inputProps}) => {
          const stateOptions = TranslatedCollections.get(EvaluationRule, "rule_type").map(({translation, value}) => ({text: translation, value}))

          return (
            <Select
              options={stateOptions}
              type="hayaSelect"
              {...inputProps}
            />
          )
        }
      }
    ],
    newIfNoId: {
      defaults: () => ({id: uuidv4()})
    }
  },
  layout: {
    select: {
      EvaluationRule: ["id", "name"]
    }
  }
}
